import { Mediator, app } from "modular-openscriptjs";
import { inform, eParse } from "../../helpers";
import { STRINGS, uc, api } from "../../declarations";
import { analyze } from "../../analytics";

const broker = app("broker");
const $e = app("$e");
const route = app("router");

export default class CapaPayment extends Mediator {
	constructor() {
		super();

		let event = {
			payment: {
				method: {
					capa: {
						process: true,
					},
				},
			},
		};

		broker.registerEvents(event);
	}

	$$payment = {
		method: {
			capa: {
				process: (ed, event) => this.processPayment(ed, event),
			},
		},
	};

	async processPayment(ed, event) {
		let { meta, message } = eParse(ed);

		this.broadcast($e.capa.needs.balance);

		if (uc.capa?.value?.balance < 1) {
			inform("Your have 0 capa in your wallet", STRINGS.ERROR);

			return this.broadcast($e.payment.has.processingError, ed);
		}

		let amount = message.get("amount", null);
		let balance = Math.floor(
			(uc.capa?.value?.balance ?? 0) * (window.capaExchangeRate ?? 1)
		);

		if (balance < amount) {
			inform(`Paying ${balance} instead of ${amount}`);
		}

		amount = balance;

		let res = await api.post(`${meta.get("route")}`, {
			method: message.method,
			information: message.paymentData,
			amount,
		});

		if (!res) {
			return this.broadcast($e.payment.has.processingError, ed);
		}

		inform(res.message, STRINGS.SUCCESS);

		analyze("wallet_spend", {
			value: Math.floor(amount / (window.capaExchangeRate ?? 1)),
			event_category: "Wallet",
			event_label: "Payment",
			occasion: route.qs.get("type"),
			wallet_currency: "Capa",
			conversion_rate: window.capaExchangeRate ?? 1,
			fiat_currency: window.userCurrency,
			fiat_amount: amount,
		});

		analyze("payment_made", {
			amount,
			currency: window.userCurrency,
			method: "capa",
		});

		return this.broadcast($e.payment.completed, ed);
	}
}

